import { MutationTree } from 'vuex'
import { Response } from '../response'
import { Doctor, DoctorOpinion, DoctorState, UserInfo } from './types'

export enum DoctorMutations {
  SET_LOADER = 'SET_LOADER',
  SET_LOADER_INFO = 'SET_LOADER_INFO',
  SET_LOADER_SEARCH_DOCTOR = 'SET_LOADER_SEARCH_DOCTOR',
  SET_DOCTOR = 'SET_DOCTOR',
  SET_USER_INFO = 'SET_USER_INFO',
  SET_REQUEST_SENT = 'SET_REQUEST_SENT',
  SET_DOCTOR_OPINIONS = 'SET_DOCTOR_OPINIONS'
}

export const mutations: MutationTree<DoctorState> = {
  [DoctorMutations.SET_LOADER](state: DoctorState, payload: boolean) {
    state.loading = payload
  },

  [DoctorMutations.SET_LOADER_INFO](state: DoctorState, payload: boolean) {
    state.loadingInfo = payload
  },

  [DoctorMutations.SET_DOCTOR](state: DoctorState, payload: Response<Doctor>) {
    state.doctor = payload.data
    state.userStatus = payload
  },

  [DoctorMutations.SET_REQUEST_SENT](state: DoctorState, payload: boolean) {
    state.requestSent = payload
  },

  [DoctorMutations.SET_USER_INFO](state: DoctorState, payload: UserInfo) {
    state.userInfo = payload
  },

  [DoctorMutations.SET_DOCTOR_OPINIONS](
    state: DoctorState,
    payload: Array<DoctorOpinion>
  ) {
    state.opinions = payload ?? []
  }
}
